import React, { useContext } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import { IConfirmActionProps } from './Interfaces'
import Provider, { ConfirmActionContext, ConfirmActionContextProvider } from './Provider'

const ConfirmActionPage: React.FC<IConfirmActionProps> = ({ id, title, content, onConfirm, onCancel, children }) => {
  const { state, handlers } = useContext<ConfirmActionContext>(ConfirmActionContextProvider)

  const onConfirmClick = () => {
    handlers.toggleDialog()
    onConfirm()
  }

  const onCancelClick = () => {
    handlers.toggleDialog()
    if (onCancel) {
      onCancel()
    }
  }

  return (
    <React.Fragment>
      <Dialog open={state.isDialogOpen} onClose={handlers.toggleDialog} aria-labelledby={`${id}-confirm-action-title`}>
        <DialogTitle id={`${id}-confirm-action-title`} style={{ color: 'rgb(52, 27, 108)' }}>
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button id={`${id}-confirm-action-cancel-button`} autoFocus onClick={onCancelClick} color="primary">
            CANCEL
          </Button>
          <Button id={`${id}-confirm-action-confirm-button`} onClick={onConfirmClick} color="primary">
            CONFIRM
          </Button>
        </DialogActions>
      </Dialog>
      {children(state.isDialogOpen, handlers.toggleDialog)}
    </React.Fragment>
  )
}

export default (props: IConfirmActionProps) => (
  <Provider>
    <ConfirmActionPage {...props} />
  </Provider>
)
